import React from "react";
import Datepicker from "react-tailwindcss-datepicker";

const Filters = ({
  selectedPublisher,
  selectedWebsite,
  dateRange,
  uniquePublishers,
  uniqueWebsites,
  handleFilterChange,
  handleResetFilters,
  setSelectedPublisher,
  setSelectedWebsite,
  setDateRange,
  setModalIsOpen,
  admin
}) => {
  return (
    <div className="bg-white shadow-lg rounded-lg p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {/* Publisher Filter */}
        <div>
          <label className="block text-gray-700 text-sm font-semibold mb-2">Publisher</label>
          <select
            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
            value={selectedPublisher}
            onChange={(e) => handleFilterChange(setSelectedPublisher, e.target.value)}
          >
            <option value="">All Publishers</option>
            {uniquePublishers.map((publisher) => (
              <option key={publisher} value={publisher}>
                {publisher}
              </option>
            ))}
          </select>
        </div>

        {/* Website Filter */}
        <div>
          <label className="block text-gray-700 text-sm font-semibold mb-2">Website</label>
          <select
            className="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
            value={selectedWebsite}
            onChange={(e) => handleFilterChange(setSelectedWebsite, e.target.value)}
          >
            <option value="">All Websites</option>
            {uniqueWebsites.map((website) => (
              <option key={website} value={website}>
                {website}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Picker */}
        <div>
          <label className="block text-gray-700 text-sm font-semibold mb-2">Date Range</label>
          <Datepicker
            value={dateRange}
            onChange={(value) => handleFilterChange(setDateRange, value)}
            placeholder="Select Date Range"
            showShortcuts={true}
            inputClassName="w-full border border-gray-300 px-4 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        {/* Reset Button */}
        <div className="flex items-end">
          <button
            onClick={handleResetFilters}
            className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition"
          >
            Reset Filters
          </button>
        </div>

        {/* Add Analytics Button (Admin Only) */}
        {admin && (
          <div className="flex items-end">
            <button
              onClick={() => setModalIsOpen(true)}
              className="w-full bg-blue-500 text-white px-5 py-2 rounded-lg hover:bg-blue-600 transition"
            >
              Add Analytics
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filters;
